// extracted by mini-css-extract-plugin
export default {"detailOuter":"eventCell-module--detailOuter--xnl5I","detailInner":"eventCell-module--detailInner--Uzkwn","isPast":"eventCell-module--isPast--7ESoH"};